export default {
  title: 'Salvează datele de contact și plată',
  form: {
    remember_me: {
      label: 'Creează un cont pentru finalizare mai rapidă a comenzilor viitoare.',
    },
  },
};
